document.addEventListener("DOMContentLoaded", function() {
  //get all groups with products
  const gtmGroups = document.querySelectorAll("[data-product-group-gtm=\"product-group-gtm\"], [data-product-group-gtm=\"product-group-gtm-cart\"]");


  gtmGroups.forEach(el => {
      let productData = [];
      let products = el.querySelectorAll(".each-product-gtm");


      //observe - products after the page load
      const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
              if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                  // Fetch the products again when new nodes are added
                  const  observed_products = el.querySelectorAll(".each-product-gtm");

                  const remove_dublicate_products = Array.from(observed_products).filter(product => !Array.from(products).includes(product));
                  

                  if (remove_dublicate_products) {
                      setupProductEventListeners(remove_dublicate_products);
                  }
              }
          });
      });

      //config observer
      const config = { childList: true, subtree: true };
      observer.observe(el, config);

      //get products in page load
      if (products) {
          setupProductEventListeners(products);
      }

      function setupProductEventListeners(products) {
          products.forEach((product, index) => {
              function handleProductClick(el) {
                  el.addEventListener("click", function () {
                      let closestProduct = el.closest(".each-product-gtm");

                      

                      //get necessary dynamic data
                      let itemListId = closestProduct.querySelector(".gtm-item-list-id").value;
                      let itemListName = closestProduct.querySelector(".gtm-item-list-name").value;
                      let itemAffiliation = closestProduct.querySelector(".gtm-affiliation").value;
                      let itemId = closestProduct.querySelector(".gtm-item_id").value;
                      let itemName = closestProduct.querySelector(".gtm-item_name").value;
                      let itemBrand = closestProduct.querySelector(".gtm-item_brand").value;

                      let itemCategory1 = closestProduct.querySelector(".gtm-item_category1")?.value;
                      let itemCategory2 = closestProduct.querySelector(".gtm-item_category2")?.value;
                      let itemCategory3 = closestProduct.querySelector(".gtm-item_category3")?.value;
                      let itemCategory4 = closestProduct.querySelector(".gtm-item_category4")?.value;
                      let itemCategory5 = closestProduct.querySelector(".gtm-item_category5")?.value;

                      let itemVariant = closestProduct.querySelector(".gtm-variant")?.value;

                      //get static data
                      let indexProduct = index + 1;
                      let quantityProduct = 1;

                      //get price & discount
                      let fullPrice = 0;
                      let discount = 0;
                      let pricePrd = closestProduct.querySelector(".gtm-price").value;
                      let comparePricePrd = closestProduct.querySelector(".gtm-discount").value;
                
                      if (parseFloat(comparePricePrd) > parseFloat(pricePrd)) {
                        fullPrice = parseFloat(pricePrd);
                          discount = parseFloat((parseFloat(comparePricePrd) - parseFloat(pricePrd)).toFixed(2));
                      } else if (pricePrd) {
                          fullPrice = parseFloat(pricePrd);
                      }

                      function getCurrencyFromMarketOrElement(pathname, product) {
                          const marketCurrencyMap = {
                              "en-uk": "GB",
                              "en-us": "US",
                              "en-row": "US",
                              "es-row": "US"
                          };
                          const locale = pathname.split("/")[1]?.toLowerCase();
                          const marketCurrency = marketCurrencyMap[locale];
                          if (marketCurrency) {
                              return marketCurrency;
                          }
                          // Fallback: get currency from hidden input
                          const currencyInput = product.querySelector(".gtm-currency");
                          return currencyInput ? currencyInput.value : "EUR";
                      }
                      const pathname = window.location.pathname;
                      let currency = getCurrencyFromMarketOrElement(pathname, closestProduct);

                      if (currency === 'GB') {
                          currency = 'GBP'
                      } else if (currency === 'US'){
                          currency = 'USD'
                      }

                      const productDataObject = {
                          'item_id': itemId,
                          'item_name': itemName,
                          'affiliation': itemAffiliation,
                          'discount': discount,
                          'index': indexProduct,
                          'item_brand': itemBrand,
                          'item_list_id': itemListId,
                          'item_list_name': itemListName,
                          'price': fullPrice,
                          'currency': currency,
                          'quantity': quantityProduct,
                      };

                      //if categories exist, add in productData
                      if (itemCategory1) productDataObject.item_category = itemCategory1;
                      if (itemCategory2) productDataObject.item_category2 = itemCategory2;
                      if (itemCategory3) productDataObject.item_category3 = itemCategory3;
                      if (itemCategory4) productDataObject.item_category4 = itemCategory4;
                      if (itemCategory5) productDataObject.item_category5 = itemCategory5;

                      //if variant exist, add in productData
                      if (itemVariant && itemVariant !== 'Default Title') {
                          productDataObject.item_variant = itemVariant;
                      }

                      //push on productData
                      productData.push(productDataObject);

                      //clear dataLayer
                      window.dataLayer =  window.dataLayer || [];

                      window.dataLayer.push({
                          event: "select_item",
                          ecommerce: {
                              'item_list_id': itemListId,
                              'item_list_name': itemListName,
                              'items': productData, //update the array with items
                          }
                      });

                      productData = [];

                  });
              }

              let cardLinkGtm2 = product.querySelectorAll(".gtm-href-link-product a");
              cardLinkGtm2.forEach((el) => {
                  if (el) handleProductClick(el);
              })
          });
      }
  });
});